export default class ThingStarController {
    /** @ngInject */
    constructor(EventEmitter, ThingsApi, ToastService) {
        this.eventEmitter = EventEmitter;
        this.api = ThingsApi;
        this.ToastService = ToastService;
    }

    $onInit() {
        if (typeof this.thingId === 'undefined') {
            this.thingId = null;
        }

        this.isProcessing = false;

        if (!this.starred || null === this.thingId) {
            this.starredIcon = 'star-o';
            this.starredAreaLabel = 'Unstarred';
        }
    }

    $onChanges(changes) {
        if (changes.starred) {
            this.starred = changes.starred.currentValue;
        }

        if (changes.thingId) {
            this.thingId = changes.thingId.currentValue;
        }

        this.calculateIcon();
    }

    toggle() {
        let apiPromise;

        if (this.isProcessing) return;

        this.starred = !this.starred;
        this.isProcessing = true;

        this.calculateIcon();

        if (this.starred) {
            apiPromise = this.api.star(this.thingId);
        } else {
            apiPromise = this.api.unstar(this.thingId);
        }

        apiPromise
            .then(() => {
                this.onToggleStatus(
                    this.eventEmitter({
                        starred: this.starred
                    })
                );

                this.ToastService.showSimpleTranslated(
                    this.starred ? 'star_was_added' : 'star_was_removed'
                );
            }, () => {
                this.ToastService.showSimpleTranslated(
                    this.starred ? 'star_wasnt_added' : 'star_wasnt_removed'
                );

                this.starred = !this.starred;
            })
            .finally(() => {
                this.isProcessing = false;
            });
    }

    calculateIcon() {
        if (this.starred) {
            this.starredIcon = 'star';
            this.starredAriaLabel = 'Starred';
        } else {
            this.starredIcon = 'star-o';
            this.starredAriaLabel = 'Unstarred';
        }
    }
}



// WEBPACK FOOTER //
// ./app/common/thing-star/thing-star.controller.js